import React from 'react';

/** Tailwind checkbox with optional label — replaces MUI Checkbox/FormControlLabel. */
const Checkbox = React.forwardRef(
  ({ label, checked, onChange, disabled = false, className = '', ...rest }, ref) => {
    const box = (
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`h-4 w-4 cursor-pointer rounded border-[#d0d5dd] accent-[#2e9e2e] disabled:cursor-not-allowed ${className}`}
        {...rest}
      />
    );
    if (!label) return box;
    return (
      <label
        className={`inline-flex items-center gap-2 text-sm text-[#212B36] ${
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
        }`}
      >
        {box}
        <span>{label}</span>
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';
export default Checkbox;
